import React, { useEffect, useState, useCallback } from 'react';
import { useFieldDetails, useMetricData } from '../../components/api/queries/hooks';
import Page from '../../components/Page';
import { HomeTopBar, RanchTable } from '../../components/rancherDashboardComponents';

export const RancherValidation = () => {
  const [ranchList, setRanchList] = useState([]);
  const [status, setStatus] = useState('ALL');
  const [allData, setAllData] = useState({});
  const [partner, setPartner] = useState({ label: 'ALL', value: 'ALL' });
  const [project, setProject] = useState({ label: 'ALL', value: 'ALL' });
  const [searchText, setSearchText] = useState('');
  const [isSearched, setIsSearched] = useState(false);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(50);

  // Fetch data WITH GLOBAL SEARCH
  const {
    data: fieldData = {},
    refetch: fieldsRefetch,
    isLoading: fieldLoading
  } = useFieldDetails({
    partnerId: partner.value !== 'ALL' ? partner.value : undefined,
    projectId: project.value !== 'ALL' ? project.value : undefined,
    search: searchText.trim() || undefined, // GLOBAL SEARCH PARAMETER
    pageNumber: page + 1,
    pageSize
  });

  const {
    data: metricData = {},
    refetch: metricsRefetch,
    isLoading: metricLoading
  } = useMetricData({
    partnerId: partner.value !== 'ALL' ? partner.value : undefined,
    projectId: project.value !== 'ALL' ? project.value : undefined,
    search: searchText.trim() || undefined
  });

  // Update data
  useEffect(() => {
    if (fieldData?.fieldDetails) {
      setRanchList(fieldData.fieldDetails);
      setAllData(fieldData);
    }
  }, [fieldData]);

  // Handle search
  const handleSearch = useCallback((searchValue) => {
    setSearchText(searchValue);
    setPage(0); // Reset to first page
  }, []);

  // Clear search
  const handleClearSearch = useCallback(() => {
    setSearchText('');
    setPage(0);
  }, []);

  return (
    <Page
      style={{
        display: 'flex',
        minHeight: '100%',
        flexDirection: 'column'
      }}
    >
      <HomeTopBar
        fieldsRefetch={fieldsRefetch}
        metricsRefetch={metricsRefetch}
        setPartner={setPartner}
        setProject={setProject}
        project={project}
        partner={partner}
        fieldLoading={fieldLoading}
        metricLoading={metricLoading}
        setIsSearched={setIsSearched}
      />

      <RanchTable
        setRanchList={setRanchList}
        status={status}
        allData={allData}
        ranchList={ranchList}
        metricData={metricData}
        fieldLoading={fieldLoading}
        metricLoading={metricLoading}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchText={searchText}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
      />
    </Page>
  );
};